import { render, staticRenderFns } from "./ANZTEXT.vue?vue&type=template&id=3e8cf60a"
import script from "./ANZTEXT.vue?vue&type=script&lang=js"
export * from "./ANZTEXT.vue?vue&type=script&lang=js"
import style0 from "./ANZTEXT.vue?vue&type=style&index=0&id=3e8cf60a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports